(function ($) {
  if (!$) return;

  const SWATCH_SEL = '.family-finish-link';

  $(function () {
    $('body')
      .off('click.familySwatch', SWATCH_SEL)
      .on('click.familySwatch', SWATCH_SEL, function (e) {
        e.stopPropagation();

        const $self = $(this);
        const title = $self.attr('data-target-title');
        const sku = $self.attr('data-target-sku');
        const url = $self.attr('data-target-url');
        const finishValue = $self.attr('data-title');

        if (!title || !url) return;

        let $card = $self.closest('.grid-item');
        if (!$card.length) $card = $self.closest('.product-item-family');
        if (!$card.length) return;

        $card.find('.product-title').each(function () {
          const $t = $(this);
          const $lang = $t.find('.lang');
          if ($lang.length) {
            $lang.text(title);
          } else {
            $t.text(title);
          }
          if ($t.is('a')) $t.attr('href', url);
        });

        $card.find('.sku').each(function () {
          $(this).html('<span>SKU : </span>' + sku);
        });

        $card
          .find('.learn_more-title, .product-grid-image, .wrapper-button-card .btn')
          .attr('href', url);

        const img = $self.attr('data-target-img');
        if (img) {
          $card
            .find('.product-grid-image > picture > *, .product-grid-image > img')
            .attr('srcset', img);
        }

        if (finishValue) {
          $card.find('.family-current-finish').text(finishValue);
        }

        $card.find('.family-finish-link').removeClass('is-selected');
        $card.find('.family-finish').removeClass('is-selected');
        $self.addClass('is-selected');
        $self.closest('.family-finish').addClass('is-selected');
      });
  });
})(window.jQuery);